<dash-paged-content contentId="closed-auctions"></dash-paged-content>
